import DesempeñoInstitucionalDto from '../domain/DesempeñoInstitucionalDto'

export default class UpdateDesempeñoInstitucional {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(desempeñoInstitucional) {
    const payload = DesempeñoInstitucionalDto.update(desempeñoInstitucional)

    await this.#repository.update(payload, desempeñoInstitucional.detalle.idEvaluado, desempeñoInstitucional.id)
    await this.#repository.updateEstatus(
      { fk_idCatEstatusEvaluacion: payload.fk_idCatEstatusEvaluacion },
      desempeñoInstitucional.detalle.idEvaluado,
      desempeñoInstitucional.id
    )
  }
}
